<template>
  <div>
    <a-form-model
      :model="form"
      v-bind="layout"
    >
      <a-form-model-item :label="$t('k_b6a559cf')">
        <span>{{ form.user }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('k_6ac42065')">
        <span>{{ currentEnvName }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.bizId"
        :label="$t('k_3c6c1804')"
      >
        <span>{{ currentBizName }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.pageId"
        :label="$t('k_59b4978')"
      >
        <span>{{ currentPageInfo }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.flowId"
        :label="$t('k_d379411b')"
      >
        <span>{{ form.flowId }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.api"
        :label="$t('k_82eeeb95')"
      >
        <span>{{ form.api }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.method"
        :label="$t('k_70f6fcda')"
      >
        <span>{{ form.method }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.permission"
        :label="$t('k_aa5c52ce')"
      >
        <span>{{ permissionMap[form.permission] || form.permission }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-if="mode !== 'approval'"
        :label="$t('k_4a278e31')"
      >
        <a-radio-group v-model="form.type">
          <a-radio-button value="role">
            {{ $t("k_da545de1") }}
          </a-radio-button>
          <a-radio-button
            value="page"
            :disabled="!!projectInfo.disabledPageApply || !!form.flowId"
          >
            {{ $t("k_59b4978") }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.type === 'page'"
        :label="$t('k_6b3f0f4a')"
      >
        <a-select
          v-model="selectedPages"
          mode="multiple"
          :filter-option="pageFilterOption"
          @change="selectedPagesChange"
        >
          <a-select-option
            v-for="page of pages"
            :key="page.id"
            :value="page.pageId"
          >
            {{ page.pageName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.type === 'role'"
        :label="$t('k_fee333d3')"
        required
      >
        <div>
          <a-select
            v-model="selectedRoles"
            :disabled="!editable"
            mode="multiple"
            :filter-option="filterOption"
            @search="onSearch"
            @change="selectedRolesChange"
          >
            <span slot="notFoundContent">
              <span v-if="searchRoleQ">{{ $t("k_c8ecd215") }}</span>
              <span v-else>
                <span>{{ $t("k_81d5cd37") }}</span>
                <span style="font-size:10px;color:#8d8d8d;font-style:italic">{{ $t("k_5b20d57") }}</span>
              </span>
            </span>
            <a-select-opt-group
              v-if="needRolePermList()"
              :label="$t('k_10dd1820')"
            >
              <a-select-option
                v-if="recommendedRoles.length === 0"
                disabled
                value=""
              >
                {{ $t("k_7f13915d") }}
                <span style="font-size:10px;color:#8d8d8d;font-style:italic"> {{ $t("k_9c3b7f23") }}</span>
              </a-select-option>
              <a-select-option
                v-for="role of recommendedRoles"
                v-else
                :key="role.name"
              >
                {{ role.cname }}
              </a-select-option>
            </a-select-opt-group>
            <a-select-opt-group
              v-if="needRolePermList()"
              :label="$t('k_aad73cc')"
            >
              <a-select-option
                v-for="role of otherRoles"
                :key="role.name"
                disabled
              >
                {{ role.cname }}
              </a-select-option>
            </a-select-opt-group>
            <a-select-option
              v-for="role of availableRoles"
              v-else
              :key="role.name"
            >
              {{ role.cname }}
            </a-select-option>
          </a-select>
          <div
            v-if="selectedRoles.length && !isMobileScreen"
            style="margin-bottom:-12px"
          >
            {{ $t("k_240d2c9d") }}
            <a-tag
              v-for="role of selectedRoles"
              :key="role"
              @click="() => {
                rolePermView.name = role;
                rolePermView.cname = roleMap[role].cname;
                rolePermView.visible = true;
              }"
            >
              {{ roleMap[role] && roleMap[role].cname }}
            </a-tag>
          </div>
        </div>
      </a-form-model-item>
      <user-role-expire-edit
        :expire="form.expire"
        :user-id="form.user"
        :project-id="projectId"
        :readonly="mode === 'approval'"
        :env="env"
        :use-first-as-default="true"
        @expireChange="(expire) => form.expire = expire"
      />
      <a-form-model-item
        :label="$t('k_c26416e6')"
        required
      >
        <a-textarea
          v-if="mode !== 'approval'"
          v-model="form.description"
          :placeholder="$t('k_41ef5058')"
        />
        <span v-else>{{ form.description || $t('k_7f13915d') }}</span>
      </a-form-model-item>
      <a-form-model-item
        v-show="hasExtraForm"
        :label="$t('k_273b1943')"
      >
        <ApplyCustomForm
          ref="extraForm"
          v-model="extraData"
          :readonly="mode === 'approval'"
          :flow-config="flowConfig"
          @updated="hasForm => hasExtraForm = hasForm"
        />
      </a-form-model-item>
    </a-form-model>
    <a-modal
      :title="rolePermView.cname"
      :visible="rolePermView.visible"
      width="64%"
      :destroy-on-close="true"
      @ok="() => rolePermView.visible = false"
      @cancel="() => (rolePermView.visible = false)"
    >
      <manage-permission
        v-if="rolePermView.visible"
        :key="rolePermView.name"
        :project-id="projectId"
        :env="env"
        :role="rolePermView.name"
        :pages="pages"
        :tag-list="tagList"
        mode="view"
        max-height="60vh"
      />
    </a-modal>
  </div>
</template>

<script>
import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import { mapState, mapActions } from 'vuex';
import { getUserId } from '@utils/userInfo';
import { BUILT_IN_ROLES, PAGE_PERM_MAPPING } from '@pages/modules/permission/constants';
import { permissionApi } from '@/services';
import ManagePermission from '@pages/modules/permission/ManagePermission';
import { flatten, keyBy } from 'lodash';
import { UserRoleExpireEdit } from '@pages/modules/permission/expire/UserRoleExpireEdit';
import { isMobileOrNarrowScreen } from '@utils/screen';
import ApplyCustomForm from './ApplyCustomForm.tsx';

export default {
  components: {
    ManagePermission,
    UserRoleExpireEdit,
    ApplyCustomForm,
  },
  props: {
    projectId: {
      type: String,
      default: '',
    },
    env: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: null,
    },
    flowConfig: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        user: getUserId(),
        env: '',
        pageId: '',
        bizId: '',
        permission: '',
        api: '',
        method: '',
        type: 'role',
        page: '',
        role: '',
        description: '',
        expireAt: 0,
        flowId: '',
      },
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      },
      hasExtraForm: false,
      extraData: null,
      searchRoleQ: '',
      roles: [],
      roleMap: {},
      pageMap: {},
      rolePermList: [],
      rolePermView: {
        visible: false,
        name: '',
        cname: '',
      },
      pages: window.xy_runtime_pages.map(p => ({
        id: p.id,
        pageName: `${p.name}(${p.path})`,
        pageId: p.pageId,
        tags: p.pageTag?.split(',').filter(Boolean)
          .map(Number) ?? [],
      })),
      tagList: [],
      selectedRoles: [],
      selectedPages: [],
      permissionMap: {
        'read.project': $t('k_18cd92c9'),
        'create.project': $t('k_68c65e73'),
        'update.project': $t('k_f712dbc7'),
        'delete.project': $t('k_533121a4'),
        'read.page': $t('k_ebf73c10'),
        'create.page': $t('k_6cbc4fd6'),
        'update.page': $t('k_4fb1a4ab'),
        'delete.page': $t('k_a636c96f'),
        'read.permission': $t('k_a5264345'),
        'update.permission': $t('k_7ee7737e'),
        'start.flow': $t('k_6bbb26c1'),
        'upload.flow': $t('k_bf460c4d'),
      },
    };
  },
  computed: {
    ...mapState({
      projectInfo: state => state.runtime.project,
      topSwitch: state => state.runtime.topSwitch,
      envList: state => state.env.envList,
    }),
    bizKey() {
      return this.projectInfo?.bizIsolation;
    },
    bizList() {
      const result = this.topSwitch[this.bizKey] || [];
      return result;
    },
    availableRoles() {
      let roles = this.roles.filter(r => !BUILT_IN_ROLES.includes(r.name));
      if (!this.form.bizId) {
        roles = roles.filter(r => r.type !== 'biz');
      }
      return roles;
    },
    recommendedRoles() {
      return this.availableRoles.filter(i => this.rolePermList.some(rp => rp.role === i.name));
    },
    otherRoles() {
      return this.availableRoles.filter(i => !this.rolePermList.some(rp => rp.role === i.name));
    },
    currentBizName() {
      const biz = this.bizList.find(i => i.value === this.form.bizId);
      return biz ? biz.label : this.form.bizId;
    },
    currentEnvName() {
      if (this.form.env === 'dev') return $t('k_803f7289');
      const env = this.envList.find(r => r.env === this.form.env);
      return env?.name ?? this.env;
    },
    currentPageInfo() {
      if (!this.form.pageId) return '';
      const page = this.pages.find(p => p.pageId === this.form.pageId);
      return page ? page.pageName : this.form.pageId;
    },
    isMobileScreen() {
      return isMobileOrNarrowScreen();
    },
  },
  watch: {
    data: {
      handler() {
        if (this.data) this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initRoles();
    this.initRolePermList();
    this.fetchEnvList();
  },
  methods: {
    ...mapActions(['fetchEnvList']),
    init() {
      this.form.user = this.data.user;
      this.form.env = this.data.env;
      this.form.pageId = this.data.pageId;
      this.form.flowId = this.data.flowId;
      this.form.permission = this.data.permission;
      this.form.bizId = this.data.bizId;
      this.form.api = this.data.api;
      this.form.method = this.data.method;
      this.form.role = this.data.role;
      this.form.description = this.data.description;
      this.form.projectName = window.xy_runtime_project.name || this.projectId;
      this.form.envName = this.currentEnvName || this.env;
      this.form.bizName = this.currentBizName || this.data.bizId;
      typeof this.data.expire === 'number' && (this.form.expire = this.data.expire);
      this.selectedRoles = this.data.role.split(',').filter(Boolean);
      this.pageMap = keyBy(this.pages, 'pageId');
      this.extraData = this.data.form;
    },
    async initRoles() {
      try {
        const resp = await permissionApi.fetchRoles(this.projectId, this.env);
        this.roles = resp;
        this.roleMap = keyBy(this.roles, 'name');
        if (this.selectedRoles.length) {
          setTimeout(() => {
            this.selectedRoles = this.selectedRoles.filter(i => this.availableRoles.some(r => r.name === i));
            if (!this.selectedRoles.length) message.warn($t('k_4f2f0dca'));
          }, 0);
        }
      } catch (error) {
        const msg = $t('k_bc39f142');
        console.error(msg, error);
        message.error(msg);
      }
    },
    needRolePermList() {
      if (!this.editable) return false;
      if (!this.form.permission) return false;
      const { permission } = this.form;
      if (this.permissionMap[permission] && permission.includes('.page') && !this.form.pageId) return false;
      return true;
    },
    async initRolePermList() {
      if (!this.needRolePermList()) return;
      try {
        const results = await Promise.all(this.form.permission.split(',').filter(Boolean)
          .map(perm => permissionApi.fetchRolesByPermission(
            this.projectId,
            this.env,
            { permission: perm, pageId: this.form.pageId || this.form.flowId },
          )));
        this.rolePermList = flatten(results);
        if (this.selectedRoles.length) {
          setTimeout(() => {
            const result = this.selectedRoles.filter(i => this.recommendedRoles.some(r => r.name === i));
            if (!result.length) message.warn($t('k_2004bff5'));
          }, 300);
        }
      } catch (error) {
        message.error($t('k_56859f51'));
      }
    },
    async apply() {
      if (this.selectedRoles.length === 0 && this.selectedPages.length === 0) {
        message.error($t('k_37ea722'));
        return;
      }
      if (!this.form.description) {
        message.error($t('k_f98f26df'));
        return;
      }
      try {
        const customFormResult = this.hasExtraForm ? await this.$refs.extraForm.uiCore.ucRootForm.validate() : [];
        if (customFormResult.some(x => x.error)) return;
      } catch (error) {
        message.error($t('k_746f16a6', { arg_0: error.message }));
        return;
      }
      const { projectId, env, roleMap, pageMap } = this;
      this.form.role = this.selectedRoles.join(',');
      this.form.page = this.selectedPages.join(',');
      const roleNames = this.selectedRoles.map(r => roleMap[r].cname).join(',');
      const pageNames = this.selectedPages.map(id => pageMap[id].pageName).join(',');
      const data = { ...this.form, roleNames, pageNames, form: this.extraData };
      if (data.pageId) data.pagePath = window.xy_runtime_pages?.find(item => item.pageId === data.pageId)?.path ?? '';
      if (data.permission) data.permissionName = PAGE_PERM_MAPPING[data.permission] || data.permission;
      delete data.user;
      try {
        const resp = await permissionApi.apply(projectId, env, data);
        return resp;
      } catch (error) {
        const msg = error.message.includes('empty handlers') ? $t('k_3eccf63') : error.message;
        message.error(msg);
      }
    },
    onSearch(q) {
      this.searchRoleQ = q;
    },
    selectedChange(selected, type) {
      if (selected.length > 5) {
        selected.pop();
        message.warn($t('k_8ceaed29', { arg_0: type }));
      }
    },
    selectedRolesChange() {
      this.selectedChange(this.selectedRoles, $t('k_da545de1'));
    },
    selectedPagesChange() {
      this.selectedChange(this.selectedPages, $t('k_59b4978'));
    },
    filterOption(inputValue, option) {
      if (!inputValue) return true;
      const q = inputValue.toLowerCase();
      if (option.key?.toLowerCase().includes(q)) return true;
      const role = this.availableRoles.find(i => i.name === option.key);
      return role?.cname.toLowerCase().includes(q);
    },
    pageFilterOption(inputValue, option) {
      if (!inputValue) return true;
      const q = inputValue.toLowerCase();
      const page = this.pages.find(i => i.id === option.key);
      return page?.pageId.toLowerCase().includes(q) || page?.pageName.toLowerCase().includes(q);
    },
  },

};
</script>

<style lang="scss" scoped>

</style>
